module.exports = __webpack_public_path__ + "static/media/right-chevron.c421d5cd.svg";